import { Component, input } from '@angular/core';

@Component({
  selector: 'app-image-panel',
  imports: [],
  templateUrl: './image-panel.html',
  styleUrl: './image-panel.scss',
})
export class ImagePanel {
  imageSrc = input<string>('');
  imageAlt = input<string>('');
  imageClass = input<string>('page-image');
  topClass = input<string>('');
  bottomClass = input<string>('');
}
